interface QueueEntry<T> {
  id: string
  processFn: () => Promise<T>
}

export function createProcessQueue<T> (opts: {
  concurrency?: number
  onItemComplete?: (id: string, result: T) => void
  onItemError?: (id: string, error: unknown) => void
  onItemFinally?: (id: string) => void
}) {
  const queue: Array<QueueEntry<T>> = []
  let activeCount = 0
  const concurrency = opts.concurrency ?? 10

  const processNext = () => {
    if (queue.length === 0 || activeCount >= concurrency) return
    activeCount++
    const entry = queue.shift()!

    entry.processFn()
      .then(result => opts.onItemComplete?.(entry.id, result))
      .catch(error => opts.onItemError?.(entry.id, error))
      .finally(() => {
        activeCount--
        opts.onItemFinally?.(entry.id)
        processNext()
      })
  }

  return {
    add (ids: Array<string>, processFn: (id: string) => Promise<T>) {
      ids.forEach(id => queue.push({ id, processFn: () => processFn(id) }))
      const slotsAvailable = Math.min(concurrency - activeCount, queue.length)
      for (let i = 0; i < slotsAvailable; i++) {
        processNext()
      }
    },
  }
}
